var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContectUsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.741,
    height: 123.592,
    viewBox: "0 0 129.741 123.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6554",
    "data-name": "Rectangle 6554",
    width: 129.742,
    height: 123.592,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6368",
    "data-name": "Rectangle 6368",
    width: 23.774,
    height: 58.914,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6369",
    "data-name": "Rectangle 6369",
    width: 26.172,
    height: 28.156,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6370",
    "data-name": "Rectangle 6370",
    width: 22.257,
    height: 14.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23376",
    "data-name": "Path 23376",
    d: "M135.148,480.5a36.265,36.265,0,1,1,32.846,20.814A36.291,36.291,0,0,1,135.148,480.5m37.26-65.461-2.7,4.157a4.1,4.1,0,0,1-3.308,1.851,43.71,43.71,0,0,0-9.861,1.477,4.094,4.094,0,0,1-3.7-.8l-3.8-3.178a4.9,4.9,0,0,0-5.668-.44l-5.343,3.216a4.9,4.9,0,0,0-2.264,5.214l1.031,4.843a4.094,4.094,0,0,1-1.027,3.644,43.718,43.718,0,0,0-5.922,8.022,4.1,4.1,0,0,1-3.184,2.056l-4.936.438a4.9,4.9,0,0,0-4.319,3.7l-1.5,6.052a4.9,4.9,0,0,0,2.086,5.288l4.157,2.7A4.1,4.1,0,0,1,124,466.584a43.721,43.721,0,0,0,1.477,9.861,4.094,4.094,0,0,1-.8,3.7l-3.178,3.8a4.9,4.9,0,0,0-.441,5.668l3.216,5.343a4.9,4.9,0,0,0,5.215,2.264l4.842-1.031a4.094,4.094,0,0,1,3.644,1.027A43.706,43.706,0,0,0,146,503.135a4.1,4.1,0,0,1,2.056,3.184l.438,4.937a4.9,4.9,0,0,0,3.7,4.319l6.052,1.5a4.9,4.9,0,0,0,5.288-2.086l2.7-4.157a4.1,4.1,0,0,1,3.308-1.851,43.72,43.72,0,0,0,9.861-1.477,4.1,4.1,0,0,1,3.7.8l3.8,3.178a4.9,4.9,0,0,0,5.668.441l5.343-3.216a4.9,4.9,0,0,0,2.264-5.214l-1.031-4.843a4.094,4.094,0,0,1,1.027-3.643,43.709,43.709,0,0,0,5.922-8.022,4.1,4.1,0,0,1,3.184-2.056l4.937-.438a4.9,4.9,0,0,0,4.319-3.7l1.5-6.052a4.9,4.9,0,0,0-2.086-5.288l-4.157-2.7a4.1,4.1,0,0,1-1.851-3.308,43.728,43.728,0,0,0-1.477-9.861,4.093,4.093,0,0,1,.8-3.7l3.178-3.8a4.9,4.9,0,0,0,.44-5.667l-3.216-5.343a4.9,4.9,0,0,0-5.214-2.264l-4.843,1.031a4.094,4.094,0,0,1-3.644-1.027,43.705,43.705,0,0,0-8.022-5.922,4.1,4.1,0,0,1-2.056-3.184l-.438-4.937a4.9,4.9,0,0,0-3.7-4.319l-6.052-1.5a4.894,4.894,0,0,0-5.288,2.086",
    transform: "translate(-115.762 -412.81)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.112,
    y1: 0.851,
    x2: 0.112,
    y2: 0.851,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23377",
    "data-name": "Path 23377",
    d: "M586.328,1288.52a15.986,15.986,0,0,0-11.223,7.3c-4.5,7.121-10.867,19.816-9.521,33.056l7.064,1.747s4.882-15.708,10.377-22.1c0,0,6.507,14.833,6.178,22.978q-.014.345-.045.674c-.747,7.969,31.237,1.487,31.237,1.487l-1.992-42.448a1.508,1.508,0,0,0-1.189-1.4,98.339,98.339,0,0,0-19.777-2.047,78.68,78.68,0,0,0-11.109.755",
    transform: "translate(-565.401 -1287.765)",
    fill: "#dd2d38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23378",
    "data-name": "Path 23378",
    d: "M1193.248,930.71a1.582,1.582,0,0,0,1.134,1.793,15.823,15.823,0,0,0,10.1-1.307,2.4,2.4,0,0,0,1.324-2.4l-.93-11.028-8.919-4.541Z",
    transform: "translate(-1193.229 -913.23)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.114,
    y1: 3.635,
    x2: -3.111,
    y2: 3.635,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23379",
    "data-name": "Path 23379",
    d: "M1139.333,735.455c.416,4.034-.031,6.767,4.721,6.833s8.279-2.859,9.753-7.179c0,0,2.326-6.666,1.182-9.061s-13.974-2.776-13.974-2.776-2.1,8.148-1.683,12.183",
    transform: "translate(-1139.279 -723.272)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.181,
    y1: 4.244,
    x2: -2.179,
    y2: 4.244,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23380",
    "data-name": "Path 23380",
    d: "M1073.187,548.583a5.6,5.6,0,0,0-.922,7.949c2.284,2.685,10.939,3.056,13.194,3.585s.636,5.854.636,5.854l.585-.093,1.246-.2a.318.318,0,0,1,.367.283l.342,3.529a.318.318,0,0,0,.29.287c.572.053,2.051-.036,4.3-1.744,2.2-1.67,1.117-2.486.43-2.791a.316.316,0,0,1-.1-.5c2.985-3.359,3.08-6.878,1.3-7.945-1.022-.613-1.677-.385-2.057-.061a.318.318,0,0,1-.527-.18c-.722-3.928-4.863-5.634-10.736-5.776-4.139-.1-5.869-1.307-6.565-2.108a.317.317,0,0,0-.549.176.318.318,0,0,1-.57.152l-.251-.334a.326.326,0,0,0-.258-.13.294.294,0,0,0-.161.047",
    transform: "translate(-1071.016 -548.536)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23381",
    "data-name": "Path 23381",
    d: "M1407.584,852.13l.9,2.043c1.725-.462,4.386-5.08,1.986-6.1a1.558,1.558,0,0,0-.609-.135c-1.875,0-2.278,4.187-2.278,4.187",
    transform: "translate(-1407.584 -847.943)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -8.735,
    y1: 12.614,
    x2: -8.729,
    y2: 12.614,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23382",
    "data-name": "Path 23382",
    d: "M1544.2,1350.873a4.516,4.516,0,0,0,.939,2.707c2.086,2.717,7.13,9.876,6.44,14.746,3.313.262,9.885,1.5,10.561,7.19a12.7,12.7,0,0,0,2.089-4.231c4.289-15.093-13.115-33.888-13.115-33.888-4.64,2.975-6.976,6.578-6.915,13.475",
    transform: "translate(-1544.204 -1337.398)",
    fill: "#dd2d38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23383",
    "data-name": "Path 23383",
    d: "M1558.926,1681.885c1.744,2.271,5.856,8.05,6.382,12.666l.642-.073c-.544-4.776-4.735-10.672-6.512-12.986Z",
    transform: "translate(-1558.926 -1681.491)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.82,
    y1: 3.258,
    x2: -4.816,
    y2: 3.258,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23384",
    "data-name": "Path 23384",
    d: "M1340.221,2003.817c-1.629,6.045-17.539,9-17.539,9v3.868s20.717,3.586,28.233-6.354c-.676-5.687-7.249-6.927-10.561-7.19a5.637,5.637,0,0,1-.132.675",
    transform: "translate(-1322.681 -2003.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.402,
    y1: 1.176,
    x2: -2.4,
    y2: 1.176,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23385",
    "data-name": "Path 23385",
    d: "M1081.6,2160.159c-5.39,2.56-4.966,4.235-4.966,4.235l13.415.422s-2.207-5.206-6.174-5.207a5.262,5.262,0,0,0-2.275.55",
    transform: "translate(-1076.625 -2159.609)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5.277,
    y1: 1.897,
    x2: -5.273,
    y2: 1.897,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23386",
    "data-name": "Path 23386",
    d: "M728.859,2191.727l-10.185.541a1.023,1.023,0,0,0-.922,1.327l.811,2.594a1.023,1.023,0,0,0,.941.718l27.93.974a1.023,1.023,0,0,0,.257-2.021l-18.555-4.11a1.037,1.037,0,0,0-.221-.024h-.054",
    transform: "translate(-717.704 -2191.725)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23387",
    "data-name": "Path 23387",
    d: "M735.61,2205.4l.688,2.971,10.542.11-.769-3.581Z",
    transform: "translate(-735.61 -2204.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23388",
    "data-name": "Path 23388",
    d: "M.031,1366.818l7.029,31.655a1.291,1.291,0,0,0,1.224,1.011l45.185,1.293a1.289,1.289,0,0,0,1.317-1.462c-.762-5.617-3.426-25.274-4.018-30.112a1.29,1.29,0,0,0-1.206-1.132l-48.195-2.823-.078,0a1.292,1.292,0,0,0-1.258,1.571",
    transform: "translate(0 -1365.246)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23389",
    "data-name": "Path 23389",
    d: "M483.433,1849.4l1.293,19.17,15.528-.329-6.678-18.955a1.49,1.49,0,0,0-1.306-.991l-7.252-.481q-.051,0-.1,0a1.49,1.49,0,0,0-1.484,1.59",
    transform: "translate(-483.43 -1847.813)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23390",
    "data-name": "Path 23390",
    d: "M423.787,2259.813v1.043a.807.807,0,0,0,.806.807h24.318a.807.807,0,0,0,.035-1.612l-24.318-1.043h-.035a.806.806,0,0,0-.806.806",
    transform: "translate(-423.787 -2259.006)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23391",
    "data-name": "Path 23391",
    d: "M1242.329,963.7l-.109.415c5.445,1.427,9.7-3.695,9.741-3.747l-.333-.271c-.041.05-4.124,4.959-9.3,3.6",
    transform: "translate(-1242.22 -960.096)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5.145,
    y1: 8.043,
    x2: -5.141,
    y2: 8.043,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23392",
    "data-name": "Path 23392",
    d: "M1211.924,1019.06l-.064.175a.6.6,0,0,0,.358.77l1.043.382a.6.6,0,0,0,.77-.358l.064-.175a.6.6,0,0,0-.358-.77l-1.043-.382a.6.6,0,0,0-.77.357",
    transform: "translate(-1211.823 -1018.666)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -22.824,
    y1: 41.556,
    x2: -22.805,
    y2: 41.556,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23393",
    "data-name": "Path 23393",
    d: "M1254.592,1049.731l.016-.012.075-.206Z",
    transform: "translate(-1254.592 -1049.514)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -635.912,
    y1: 344.595,
    x2: -635.406,
    y2: 344.595,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23394",
    "data-name": "Path 23394",
    d: "M1253.635,1036.634a.6.6,0,0,0,.264-.312l.044-.12.021-.058a.6.6,0,0,0,.006-.4Z",
    transform: "translate(-1253.635 -1035.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -154.088,
    y1: 85.309,
    x2: -153.965,
    y2: 85.309,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23395",
    "data-name": "Path 23395",
    d: "M1253.17,1036.167l.022-.012.336-.885-.008-.023Z",
    transform: "translate(-1253.17 -1035.247)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -163.004,
    y1: 82.084,
    x2: -162.874,
    y2: 82.084,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23396",
    "data-name": "Path 23396",
    d: "M1252.717,1035.727l.021-.01.349-.92-.009-.022Z",
    transform: "translate(-1252.717 -1034.775)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -157.315,
    y1: 79.32,
    x2: -157.189,
    y2: 79.32,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23397",
    "data-name": "Path 23397",
    d: "M1252.273,1035.311l.021-.009.361-.952-.009-.021Z",
    transform: "translate(-1252.273 -1034.329)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -152.399,
    y1: 76.921,
    x2: -152.278,
    y2: 76.921,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23398",
    "data-name": "Path 23398",
    d: "M1251.838,1034.915l.02-.008.373-.982-.01-.02Z",
    transform: "translate(-1251.838 -1033.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -148.077,
    y1: 74.815,
    x2: -147.958,
    y2: 74.815,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23399",
    "data-name": "Path 23399",
    d: "M1251.41,1034.539l.02-.007.383-1.01-.01-.019Z",
    transform: "translate(-1251.41 -1033.503)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -144.29,
    y1: 72.964,
    x2: -144.175,
    y2: 72.964,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23400",
    "data-name": "Path 23400",
    d: "M1250.99,1034.179l.02-.006.393-1.036-.01-.018Z",
    transform: "translate(-1250.99 -1033.119)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -140.906,
    y1: 71.315,
    x2: -140.794,
    y2: 71.315,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23401",
    "data-name": "Path 23401",
    d: "M1250.576,1033.836l.019-.005.4-1.06-.011-.017Z",
    transform: "translate(-1250.576 -1032.753)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -137.898,
    y1: 69.847,
    x2: -137.788,
    y2: 69.847,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23402",
    "data-name": "Path 23402",
    d: "M1250.169,1033.508l.019,0,.411-1.083-.011-.016Z",
    transform: "translate(-1250.169 -1032.404)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -135.209,
    y1: 68.533,
    x2: -135.101,
    y2: 68.533,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23403",
    "data-name": "Path 23403",
    d: "M1249.766,1033.193l.019,0,.419-1.1-.011-.016Z",
    transform: "translate(-1249.766 -1032.069)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -132.771,
    y1: 67.346,
    x2: -132.664,
    y2: 67.346,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23404",
    "data-name": "Path 23404",
    d: "M1249.37,1032.891l.018,0,.426-1.124-.012-.015Z",
    transform: "translate(-1249.37 -1031.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -130.578,
    y1: 66.281,
    x2: -130.474,
    y2: 66.281,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23405",
    "data-name": "Path 23405",
    d: "M1248.979,1032.6l.018,0,.433-1.142-.012-.014Z",
    transform: "translate(-1248.979 -1031.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -128.617,
    y1: 65.318,
    x2: -128.514,
    y2: 65.318,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23406",
    "data-name": "Path 23406",
    d: "M1248.592,1032.324l.018,0,.439-1.159-.012-.014Z",
    transform: "translate(-1248.592 -1031.149)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -126.813,
    y1: 64.447,
    x2: -126.711,
    y2: 64.447,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23407",
    "data-name": "Path 23407",
    d: "M1248.209,1032.055l.018,0,.446-1.175-.012-.013Z",
    transform: "translate(-1248.209 -1030.866)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -125.171,
    y1: 63.657,
    x2: -125.071,
    y2: 63.657,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23408",
    "data-name": "Path 23408",
    d: "M1247.832,1031.8h.018l.451-1.189-.012-.013Z",
    transform: "translate(-1247.832 -1030.597)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -123.708,
    y1: 62.947,
    x2: -123.609,
    y2: 62.947,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23409",
    "data-name": "Path 23409",
    d: "M1247.459,1031.555h.017l.456-1.2-.013-.012Z",
    transform: "translate(-1247.459 -1030.339)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -122.358,
    y1: 62.305,
    x2: -122.259,
    y2: 62.305,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23410",
    "data-name": "Path 23410",
    d: "M1247.09,1031.318h.017l.461-1.216-.013-.012Z",
    transform: "translate(-1247.09 -1030.091)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -121.158,
    y1: 61.723,
    x2: -121.061,
    y2: 61.723,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23411",
    "data-name": "Path 23411",
    d: "M1246.724,1031.091h.017l.465-1.227-.013-.011Z",
    transform: "translate(-1246.724 -1029.853)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -120.05,
    y1: 61.183,
    x2: -119.954,
    y2: 61.183,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23412",
    "data-name": "Path 23412",
    d: "M1246.364,1030.874h.017l.469-1.238-.013-.011Z",
    transform: "translate(-1246.364 -1029.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -119.097,
    y1: 60.695,
    x2: -119.002,
    y2: 60.695,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23413",
    "data-name": "Path 23413",
    d: "M1246.006,1030.666h.016l.473-1.248-.013-.01Z",
    transform: "translate(-1246.006 -1029.41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -118.205,
    y1: 60.259,
    x2: -118.111,
    y2: 60.259,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23414",
    "data-name": "Path 23414",
    d: "M1245.651,1030.466l.016,0,.476-1.256-.014-.01Z",
    transform: "translate(-1245.651 -1029.202)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -117.393,
    y1: 59.871,
    x2: -117.299,
    y2: 59.871,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23415",
    "data-name": "Path 23415",
    d: "M1245.3,1030.275l.016,0,.479-1.264-.014-.009Z",
    transform: "translate(-1245.301 -1029.004)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -116.711,
    y1: 59.529,
    x2: -116.618,
    y2: 59.529,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23416",
    "data-name": "Path 23416",
    d: "M1244.955,1030.092l.016,0,.482-1.271-.014-.009Z",
    transform: "translate(-1244.955 -1028.815)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -116.101,
    y1: 59.231,
    x2: -116.008,
    y2: 59.231,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23417",
    "data-name": "Path 23417",
    d: "M1244.611,1029.919l.016,0,.484-1.277-.014-.008Z",
    transform: "translate(-1244.611 -1028.636)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -115.561,
    y1: 58.976,
    x2: -115.468,
    y2: 58.976,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23418",
    "data-name": "Path 23418",
    d: "M1244.271,1029.752l.016,0,.486-1.283-.014-.008Z",
    transform: "translate(-1244.271 -1028.465)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -115.103,
    y1: 58.759,
    x2: -115.011,
    y2: 58.759,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23419",
    "data-name": "Path 23419",
    d: "M1243.935,1029.594l.016,0,.488-1.287-.014-.008Z",
    transform: "translate(-1243.935 -1028.304)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -114.734,
    y1: 58.584,
    x2: -114.642,
    y2: 58.584,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23420",
    "data-name": "Path 23420",
    d: "M1243.6,1029.444l.016,0,.489-1.29-.014-.007Z",
    transform: "translate(-1243.601 -1028.151)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -114.417,
    y1: 58.445,
    x2: -114.325,
    y2: 58.445,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23421",
    "data-name": "Path 23421",
    d: "M1243.271,1029.3l.015,0,.49-1.293-.015-.007Z",
    transform: "translate(-1243.271 -1028.006)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -114.176,
    y1: 58.341,
    x2: -114.085,
    y2: 58.341,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23422",
    "data-name": "Path 23422",
    d: "M1242.945,1029.167l.015.005.491-1.3-.015-.006Z",
    transform: "translate(-1242.945 -1027.87)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -114.021,
    y1: 58.273,
    x2: -113.929,
    y2: 58.273,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23423",
    "data-name": "Path 23423",
    d: "M1242.62,1029.04l.007,0,.008,0,.492-1.3-.015-.006Z",
    transform: "translate(-1242.62 -1027.743)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -113.907,
    y1: 58.24,
    x2: -113.816,
    y2: 58.24,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23424",
    "data-name": "Path 23424",
    d: "M1242.3,1028.92l.015.005.492-1.3h0l-.011,0Z",
    transform: "translate(-1242.296 -1027.623)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -113.848,
    y1: 58.24,
    x2: -113.757,
    y2: 58.24,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23425",
    "data-name": "Path 23425",
    d: "M1241.973,1028.8l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1241.973 -1027.506)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -113.816,
    y1: 58.246,
    x2: -113.724,
    y2: 58.246,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23426",
    "data-name": "Path 23426",
    d: "M1241.649,1028.683l.015.006.492-1.3-.015-.006Z",
    transform: "translate(-1241.649 -1027.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -113.776,
    y1: 58.247,
    x2: -113.685,
    y2: 58.247,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23427",
    "data-name": "Path 23427",
    d: "M1241.325,1028.565l.015.006.492-1.3h0l-.013,0Z",
    transform: "translate(-1241.325 -1027.268)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -113.745,
    y1: 58.253,
    x2: -113.654,
    y2: 58.253,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23428",
    "data-name": "Path 23428",
    d: "M1241,1028.447l.015.005.492-1.3-.01,0,0,0Z",
    transform: "translate(-1241.002 -1027.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -113.718,
    y1: 58.257,
    x2: -113.627,
    y2: 58.257,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23429",
    "data-name": "Path 23429",
    d: "M1240.679,1028.328l.015.006.492-1.3-.014-.005h0Z",
    transform: "translate(-1240.679 -1027.031)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -113.699,
    y1: 58.26,
    x2: -113.607,
    y2: 58.26,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23430",
    "data-name": "Path 23430",
    d: "M1240.355,1028.21l.015.006.492-1.3h0l-.015-.005Z",
    transform: "translate(-1240.355 -1026.913)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -113.669,
    y1: 58.266,
    x2: -113.577,
    y2: 58.266,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23431",
    "data-name": "Path 23431",
    d: "M1240.031,1028.091l.015.006.492-1.3-.011,0h0Z",
    transform: "translate(-1240.031 -1026.794)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -113.639,
    y1: 58.27,
    x2: -113.548,
    y2: 58.27,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23432",
    "data-name": "Path 23432",
    d: "M1239.708,1027.973l.015.005.492-1.3,0,0-.01,0Z",
    transform: "translate(-1239.708 -1026.676)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -113.6,
    y1: 58.275,
    x2: -113.508,
    y2: 58.275,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23433",
    "data-name": "Path 23433",
    d: "M1239.384,1027.855l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1239.384 -1026.558)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -113.57,
    y1: 58.278,
    x2: -113.478,
    y2: 58.278,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23434",
    "data-name": "Path 23434",
    d: "M1239.06,1027.737l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1239.06 -1026.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -113.54,
    y1: 58.285,
    x2: -113.449,
    y2: 58.285,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23435",
    "data-name": "Path 23435",
    d: "M1238.737,1027.618l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1238.737 -1026.321)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -113.522,
    y1: 58.287,
    x2: -113.43,
    y2: 58.287,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23436",
    "data-name": "Path 23436",
    d: "M1238.413,1027.5l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1238.413 -1026.203)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -113.48,
    y1: 58.293,
    x2: -113.388,
    y2: 58.293,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23437",
    "data-name": "Path 23437",
    d: "M1238.09,1027.381l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1238.09 -1026.084)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -113.461,
    y1: 58.295,
    x2: -113.37,
    y2: 58.295,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23438",
    "data-name": "Path 23438",
    d: "M1237.766,1027.263l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1237.766 -1025.966)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -113.422,
    y1: 58.301,
    x2: -113.33,
    y2: 58.301,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23439",
    "data-name": "Path 23439",
    d: "M1237.443,1027.145l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1237.443 -1025.848)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -113.392,
    y1: 58.306,
    x2: -113.3,
    y2: 58.306,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23440",
    "data-name": "Path 23440",
    d: "M1237.119,1027.026l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1237.119 -1025.729)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -113.362,
    y1: 58.308,
    x2: -113.271,
    y2: 58.308,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23441",
    "data-name": "Path 23441",
    d: "M1236.8,1026.907l.015.006.492-1.3-.013,0h0Z",
    transform: "translate(-1236.796 -1025.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -113.343,
    y1: 58.312,
    x2: -113.251,
    y2: 58.312,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23442",
    "data-name": "Path 23442",
    d: "M1236.472,1026.788l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1236.472 -1025.491)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -113.302,
    y1: 58.314,
    x2: -113.21,
    y2: 58.314,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23443",
    "data-name": "Path 23443",
    d: "M1236.149,1026.67l.015.005.492-1.3-.013,0h0Z",
    transform: "translate(-1236.149 -1025.373)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -113.284,
    y1: 58.321,
    x2: -113.192,
    y2: 58.321,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23444",
    "data-name": "Path 23444",
    d: "M1235.825,1026.552l.015.005.492-1.3h0l-.014-.005Z",
    transform: "translate(-1235.825 -1025.255)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -113.244,
    y1: 58.324,
    x2: -113.152,
    y2: 58.324,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23445",
    "data-name": "Path 23445",
    d: "M1235.5,1026.433l.015.005.492-1.3-.011,0h0Z",
    transform: "translate(-1235.502 -1025.136)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -113.223,
    y1: 58.327,
    x2: -113.131,
    y2: 58.327,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23446",
    "data-name": "Path 23446",
    d: "M1235.178,1026.315l.015.005.492-1.3-.013,0h0Z",
    transform: "translate(-1235.178 -1025.018)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -113.196,
    y1: 58.333,
    x2: -113.104,
    y2: 58.333,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23447",
    "data-name": "Path 23447",
    d: "M1234.855,1026.2l.015.005.492-1.3h0l-.014-.005Z",
    transform: "translate(-1234.855 -1024.9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -113.175,
    y1: 58.337,
    x2: -113.083,
    y2: 58.337,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23448",
    "data-name": "Path 23448",
    d: "M1234.531,1026.078l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1234.531 -1024.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -113.134,
    y1: 58.342,
    x2: -113.042,
    y2: 58.342,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23449",
    "data-name": "Path 23449",
    d: "M1234.207,1025.96l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1234.207 -1024.663)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -113.106,
    y1: 58.346,
    x2: -113.014,
    y2: 58.346,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23450",
    "data-name": "Path 23450",
    d: "M1233.883,1025.841l.015.006.492-1.3-.013,0h0Z",
    transform: "translate(-1233.883 -1024.544)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -113.065,
    y1: 58.35,
    x2: -112.973,
    y2: 58.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23451",
    "data-name": "Path 23451",
    d: "M1233.56,1025.723l.015.005.492-1.3h0l-.013,0Z",
    transform: "translate(-1233.56 -1024.426)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -113.037,
    y1: 58.355,
    x2: -112.946,
    y2: 58.355,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23452",
    "data-name": "Path 23452",
    d: "M1233.237,1025.605l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1233.237 -1024.308)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -113.017,
    y1: 58.358,
    x2: -112.925,
    y2: 58.358,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23453",
    "data-name": "Path 23453",
    d: "M1232.913,1025.487l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1232.913 -1024.19)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -112.988,
    y1: 58.365,
    x2: -112.897,
    y2: 58.365,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23454",
    "data-name": "Path 23454",
    d: "M1232.589,1025.368l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1232.589 -1024.071)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -112.957,
    y1: 58.367,
    x2: -112.866,
    y2: 58.367,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23455",
    "data-name": "Path 23455",
    d: "M1232.266,1025.25l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1232.266 -1023.953)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -112.918,
    y1: 58.373,
    x2: -112.826,
    y2: 58.373,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23456",
    "data-name": "Path 23456",
    d: "M1231.942,1025.131l.015.006.492-1.3-.012,0h0Z",
    transform: "translate(-1231.942 -1023.834)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -112.888,
    y1: 58.375,
    x2: -112.796,
    y2: 58.375,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23457",
    "data-name": "Path 23457",
    d: "M1231.619,1025.012l.015.005.492-1.3-.005,0-.01,0Z",
    transform: "translate(-1231.619 -1023.715)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -112.868,
    y1: 58.38,
    x2: -112.777,
    y2: 58.38,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23458",
    "data-name": "Path 23458",
    d: "M1231.3,1024.895l.015.005.492-1.3-.012,0h0Z",
    transform: "translate(-1231.295 -1023.597)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -112.839,
    y1: 58.384,
    x2: -112.747,
    y2: 58.384,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23459",
    "data-name": "Path 23459",
    d: "M1230.971,1024.775l.015.006.492-1.3-.015-.006Z",
    transform: "translate(-1230.971 -1023.478)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -112.798,
    y1: 58.386,
    x2: -112.706,
    y2: 58.386,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23460",
    "data-name": "Path 23460",
    d: "M1230.648,1024.657l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1230.648 -1023.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -112.778,
    y1: 58.392,
    x2: -112.687,
    y2: 58.392,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23461",
    "data-name": "Path 23461",
    d: "M1230.324,1024.539l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1230.324 -1023.242)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -112.727,
    y1: 58.397,
    x2: -112.635,
    y2: 58.397,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23462",
    "data-name": "Path 23462",
    d: "M1230,1024.42l.015.006.492-1.3-.011,0h0Z",
    transform: "translate(-1230 -1023.123)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -112.711,
    y1: 58.4,
    x2: -112.62,
    y2: 58.4,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23463",
    "data-name": "Path 23463",
    d: "M1229.677,1024.3l.015.006.492-1.3,0,0-.01,0Z",
    transform: "translate(-1229.677 -1023.005)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -112.68,
    y1: 58.405,
    x2: -112.589,
    y2: 58.405,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23464",
    "data-name": "Path 23464",
    d: "M1229.354,1024.183l.015.005.492-1.3-.008,0-.007,0Z",
    transform: "translate(-1229.354 -1022.886)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -112.661,
    y1: 58.409,
    x2: -112.569,
    y2: 58.409,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23465",
    "data-name": "Path 23465",
    d: "M1229.03,1024.065l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1229.03 -1022.768)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -112.62,
    y1: 58.413,
    x2: -112.528,
    y2: 58.413,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23466",
    "data-name": "Path 23466",
    d: "M1228.707,1023.947l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1228.707 -1022.65)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -112.602,
    y1: 58.42,
    x2: -112.51,
    y2: 58.42,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23467",
    "data-name": "Path 23467",
    d: "M1228.383,1023.828l.015.005.492-1.3-.012,0h0Z",
    transform: "translate(-1228.383 -1022.531)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -112.573,
    y1: 58.422,
    x2: -112.482,
    y2: 58.422,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23468",
    "data-name": "Path 23468",
    d: "M1228.059,1023.71l.015.006.492-1.3h0l-.013,0Z",
    transform: "translate(-1228.059 -1022.413)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -112.531,
    y1: 58.426,
    x2: -112.439,
    y2: 58.426,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23469",
    "data-name": "Path 23469",
    d: "M1227.736,1023.591l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1227.736 -1022.294)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -112.513,
    y1: 58.43,
    x2: -112.421,
    y2: 58.43,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23470",
    "data-name": "Path 23470",
    d: "M1227.413,1023.473l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1227.413 -1022.176)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -112.483,
    y1: 58.435,
    x2: -112.391,
    y2: 58.435,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23471",
    "data-name": "Path 23471",
    d: "M1227.088,1023.354l.015.005.492-1.3-.01,0-.005,0Z",
    transform: "translate(-1227.088 -1022.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -112.443,
    y1: 58.437,
    x2: -112.352,
    y2: 58.437,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23472",
    "data-name": "Path 23472",
    d: "M1226.765,1023.237l.015.006.492-1.3,0,0-.01,0Z",
    transform: "translate(-1226.765 -1021.94)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -112.424,
    y1: 58.445,
    x2: -112.332,
    y2: 58.445,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23473",
    "data-name": "Path 23473",
    d: "M1226.442,1023.118l.015.006.492-1.3-.015-.006Z",
    transform: "translate(-1226.442 -1021.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -112.395,
    y1: 58.449,
    x2: -112.304,
    y2: 58.449,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23474",
    "data-name": "Path 23474",
    d: "M1226.118,1023l.015.005.492-1.3h0l-.011,0Z",
    transform: "translate(-1226.118 -1021.702)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -112.354,
    y1: 58.452,
    x2: -112.263,
    y2: 58.452,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23475",
    "data-name": "Path 23475",
    d: "M1225.8,1022.88l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1225.795 -1021.583)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -112.333,
    y1: 58.454,
    x2: -112.242,
    y2: 58.454,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23476",
    "data-name": "Path 23476",
    d: "M1225.471,1022.762l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1225.471 -1021.465)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -112.304,
    y1: 58.46,
    x2: -112.212,
    y2: 58.46,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23477",
    "data-name": "Path 23477",
    d: "M1225.147,1022.644l.015.006.492-1.3-.015-.005h0Z",
    transform: "translate(-1225.147 -1021.347)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -112.265,
    y1: 58.464,
    x2: -112.174,
    y2: 58.464,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23478",
    "data-name": "Path 23478",
    d: "M1224.823,1022.525l.015.005.492-1.3h0l-.015-.006Z",
    transform: "translate(-1224.823 -1021.228)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -112.236,
    y1: 58.468,
    x2: -112.144,
    y2: 58.468,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23479",
    "data-name": "Path 23479",
    d: "M1224.5,1022.407l.015.005.492-1.3-.015-.006Z",
    transform: "translate(-1224.5 -1021.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -112.205,
    y1: 58.472,
    x2: -112.113,
    y2: 58.472,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23480",
    "data-name": "Path 23480",
    d: "M1224.177,1022.288l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1224.177 -1020.991)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -112.175,
    y1: 58.475,
    x2: -112.084,
    y2: 58.475,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23481",
    "data-name": "Path 23481",
    d: "M1223.853,1022.17l.015.005.492-1.3-.009,0-.006,0Z",
    transform: "translate(-1223.853 -1020.873)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -112.148,
    y1: 58.481,
    x2: -112.056,
    y2: 58.481,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23482",
    "data-name": "Path 23482",
    d: "M1223.529,1022.052l.015.005.492-1.3-.008,0-.007,0Z",
    transform: "translate(-1223.529 -1020.755)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -112.117,
    y1: 58.485,
    x2: -112.025,
    y2: 58.485,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23483",
    "data-name": "Path 23483",
    d: "M1223.206,1021.933l.015.005.492-1.3-.006,0-.009,0Z",
    transform: "translate(-1223.206 -1020.636)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -112.089,
    y1: 58.489,
    x2: -111.997,
    y2: 58.489,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23484",
    "data-name": "Path 23484",
    d: "M1222.882,1021.815l.015.006.492-1.3-.011,0h0Z",
    transform: "translate(-1222.882 -1020.518)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -112.056,
    y1: 58.494,
    x2: -111.965,
    y2: 58.494,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23485",
    "data-name": "Path 23485",
    d: "M1222.559,1021.7l.015.005.492-1.3h0l-.012,0Z",
    transform: "translate(-1222.559 -1020.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -112.028,
    y1: 58.5,
    x2: -111.937,
    y2: 58.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23486",
    "data-name": "Path 23486",
    d: "M1222.236,1021.578l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1222.236 -1020.281)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -112.01,
    y1: 58.502,
    x2: -111.918,
    y2: 58.502,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23487",
    "data-name": "Path 23487",
    d: "M1221.912,1021.46l.015.005.492-1.3-.015-.005Z",
    transform: "translate(-1221.912 -1020.163)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -111.979,
    y1: 58.506,
    x2: -111.887,
    y2: 58.506,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23488",
    "data-name": "Path 23488",
    d: "M1221.588,1021.341l.015.005.492-1.3-.009,0-.006,0Z",
    transform: "translate(-1221.588 -1020.044)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -111.949,
    y1: 58.511,
    x2: -111.858,
    y2: 58.511,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23489",
    "data-name": "Path 23489",
    d: "M1221.265,1021.223l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1221.265 -1019.926)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -111.93,
    y1: 58.515,
    x2: -111.838,
    y2: 58.515,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23490",
    "data-name": "Path 23490",
    d: "M1220.941,1021.105l.015.005.492-1.3h0l-.012,0Z",
    transform: "translate(-1220.941 -1019.808)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -111.89,
    y1: 58.521,
    x2: -111.798,
    y2: 58.521,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23491",
    "data-name": "Path 23491",
    d: "M1220.617,1020.986l.015.005.492-1.3h0l-.012,0Z",
    transform: "translate(-1220.617 -1019.689)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -111.848,
    y1: 58.523,
    x2: -111.756,
    y2: 58.523,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23492",
    "data-name": "Path 23492",
    d: "M1220.294,1020.867h0l.014.005.492-1.3-.015-.006Z",
    transform: "translate(-1220.294 -1019.57)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -111.818,
    y1: 58.527,
    x2: -111.726,
    y2: 58.527,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23493",
    "data-name": "Path 23493",
    d: "M1219.972,1020.749l.015.006.492-1.3-.014-.005h0Z",
    transform: "translate(-1219.972 -1019.452)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -111.811,
    y1: 58.532,
    x2: -111.719,
    y2: 58.532,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23494",
    "data-name": "Path 23494",
    d: "M1219.653,1020.634l.015.006.492-1.3-.015-.005Z",
    transform: "translate(-1219.653 -1019.338)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -111.833,
    y1: 58.555,
    x2: -111.741,
    y2: 58.555,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23495",
    "data-name": "Path 23495",
    d: "M1219.338,1020.527l.015.007.492-1.3-.015,0Z",
    transform: "translate(-1219.338 -1019.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -111.917,
    y1: 58.615,
    x2: -111.825,
    y2: 58.615,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23496",
    "data-name": "Path 23496",
    d: "M1219.026,1020.428l.015.007.491-1.294-.016,0Z",
    transform: "translate(-1219.026 -1019.136)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -112.043,
    y1: 58.708,
    x2: -111.951,
    y2: 58.708,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23497",
    "data-name": "Path 23497",
    d: "M1218.717,1020.337l.014.007.49-1.292-.016,0Z",
    transform: "translate(-1218.717 -1019.048)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -112.252,
    y1: 58.838,
    x2: -112.16,
    y2: 58.838,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23498",
    "data-name": "Path 23498",
    d: "M1218.412,1020.254l.014.008.489-1.289-.016,0Z",
    transform: "translate(-1218.412 -1018.969)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -112.544,
    y1: 59.008,
    x2: -112.452,
    y2: 59.008,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23499",
    "data-name": "Path 23499",
    d: "M1218.11,1020.178l.014.008.487-1.285-.016,0Z",
    transform: "translate(-1218.11 -1018.898)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -112.892,
    y1: 59.212,
    x2: -112.799,
    y2: 59.212,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23500",
    "data-name": "Path 23500",
    d: "M1217.811,1020.11l.014.009.485-1.28-.016,0Z",
    transform: "translate(-1217.811 -1018.836)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -113.317,
    y1: 59.457,
    x2: -113.224,
    y2: 59.457,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23501",
    "data-name": "Path 23501",
    d: "M1217.516,1020.052l.014.009.483-1.274-.016,0Z",
    transform: "translate(-1217.516 -1018.784)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -113.818,
    y1: 59.744,
    x2: -113.725,
    y2: 59.744,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23502",
    "data-name": "Path 23502",
    d: "M1217.224,1020l.014.01.481-1.268-.016,0Z",
    transform: "translate(-1217.224 -1018.741)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -114.38,
    y1: 60.074,
    x2: -114.286,
    y2: 60.074,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23503",
    "data-name": "Path 23503",
    d: "M1216.936,1019.96l.013.01.478-1.26-.017,0Z",
    transform: "translate(-1216.936 -1018.708)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -115.057,
    y1: 60.451,
    x2: -114.963,
    y2: 60.451,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23504",
    "data-name": "Path 23504",
    d: "M1216.652,1019.927l.013.01.475-1.252h-.017Z",
    transform: "translate(-1216.652 -1018.684)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -115.816,
    y1: 60.873,
    x2: -115.721,
    y2: 60.873,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23505",
    "data-name": "Path 23505",
    d: "M1216.371,1019.9l.013.011.471-1.243h-.017Z",
    transform: "translate(-1216.371 -1018.67)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -116.667,
    y1: 61.347,
    x2: -116.571,
    y2: 61.347,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23506",
    "data-name": "Path 23506",
    d: "M1216.558,1018.666l-.463,1.222.013.011.468-1.233h-.017",
    transform: "translate(-1216.095 -1018.666)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -117.622,
    y1: 61.874,
    x2: -117.525,
    y2: 61.874,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23507",
    "data-name": "Path 23507",
    d: "M1216.281,1018.667l-.459,1.21.012.012.463-1.222h-.017",
    transform: "translate(-1215.822 -1018.667)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -118.686,
    y1: 62.448,
    x2: -118.588,
    y2: 62.448,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23508",
    "data-name": "Path 23508",
    d: "M1216.008,1018.675l-.454,1.2.012.012.459-1.209h-.018",
    transform: "translate(-1215.554 -1018.674)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -119.851,
    y1: 63.072,
    x2: -119.752,
    y2: 63.072,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23509",
    "data-name": "Path 23509",
    d: "M1215.738,1018.693l-.448,1.182.012.013.454-1.2h-.018",
    transform: "translate(-1215.29 -1018.692)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -121.153,
    y1: 63.762,
    x2: -121.054,
    y2: 63.762,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23510",
    "data-name": "Path 23510",
    d: "M1215.474,1018.724l-.443,1.167.012.013.448-1.182-.018,0",
    transform: "translate(-1215.031 -1018.722)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -122.608,
    y1: 64.527,
    x2: -122.507,
    y2: 64.527,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23511",
    "data-name": "Path 23511",
    d: "M1215.212,1018.766l-.436,1.15.012.014.443-1.167-.018,0",
    transform: "translate(-1214.776 -1018.763)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -124.208,
    y1: 65.368,
    x2: -124.106,
    y2: 65.368,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23512",
    "data-name": "Path 23512",
    d: "M1214.956,1018.82l-.429,1.133.011.015.436-1.151-.018,0",
    transform: "translate(-1214.526 -1018.817)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -125.975,
    y1: 66.301,
    x2: -125.871,
    y2: 66.301,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23513",
    "data-name": "Path 23513",
    d: "M1214.7,1018.888l-.422,1.114.011.015.43-1.133-.018,0",
    transform: "translate(-1214.282 -1018.884)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -127.939,
    y1: 67.334,
    x2: -127.834,
    y2: 67.334,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23514",
    "data-name": "Path 23514",
    d: "M1214.458,1018.969l-.415,1.094.011.016.422-1.114-.019,0",
    transform: "translate(-1214.043 -1018.965)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -130.094,
    y1: 68.477,
    x2: -129.987,
    y2: 68.477,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23515",
    "data-name": "Path 23515",
    d: "M1214.216,1019.066l-.406,1.072.011.017.415-1.093-.019.005",
    transform: "translate(-1213.81 -1019.061)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -132.527,
    y1: 69.747,
    x2: -132.418,
    y2: 69.747,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23516",
    "data-name": "Path 23516",
    d: "M1213.982,1019.178l-.4,1.048.011.017.406-1.072-.019.006",
    transform: "translate(-1213.584 -1019.172)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -135.233,
    y1: 71.16,
    x2: -135.122,
    y2: 71.16,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23517",
    "data-name": "Path 23517",
    d: "M1213.753,1019.307l-.388,1.023.01.018.4-1.048-.02.007",
    transform: "translate(-1213.365 -1019.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -138.244,
    y1: 72.737,
    x2: -138.13,
    y2: 72.737,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23518",
    "data-name": "Path 23518",
    d: "M1213.53,1019.454l-.378,1,.01.019.388-1.023-.02.008",
    transform: "translate(-1213.152 -1019.446)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -141.642,
    y1: 74.507,
    x2: -141.525,
    y2: 74.507,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23519",
    "data-name": "Path 23519",
    d: "M1213.316,1019.62l-.367.968.01.02.378-1-.02.009",
    transform: "translate(-1212.949 -1019.611)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -145.489,
    y1: 76.507,
    x2: -145.369,
    y2: 76.507,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23520",
    "data-name": "Path 23520",
    d: "M1213.109,1019.808l-.355.936.009.021.367-.968-.021.01",
    transform: "translate(-1212.754 -1019.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -149.832,
    y1: 78.783,
    x2: -149.708,
    y2: 78.783,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23521",
    "data-name": "Path 23521",
    d: "M1212.912,1020.021l-.342.9.009.023.355-.936-.021.011",
    transform: "translate(-1212.57 -1020.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -154.88,
    y1: 81.394,
    x2: -154.752,
    y2: 81.394,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23522",
    "data-name": "Path 23522",
    d: "M1212.726,1020.261l-.328.866.008.024.342-.9-.022.013",
    transform: "translate(-1212.398 -1020.248)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -160.753,
    y1: 84.415,
    x2: -160.62,
    y2: 84.415,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23523",
    "data-name": "Path 23523",
    d: "M1212.553,1020.531l-.313.826.007.026.329-.866-.022.014",
    transform: "translate(-1212.24 -1020.517)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -167.691,
    y1: 87.968,
    x2: -167.553,
    y2: 87.968,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23524",
    "data-name": "Path 23524",
    d: "M1212.4,1020.839l-.3.782.006.028.313-.826-.023.016",
    transform: "translate(-1212.099 -1020.823)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -176.021,
    y1: 92.211,
    x2: -175.876,
    y2: 92.211,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23525",
    "data-name": "Path 23525",
    d: "M1212.257,1021.191l-.278.733c0,.01,0,.02.006.03l.3-.782-.024.019",
    transform: "translate(-1211.979 -1021.172)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -186.318,
    y1: 97.382,
    x2: -186.165,
    y2: 97.382,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23526",
    "data-name": "Path 23526",
    d: "M1212.143,1021.6l-.257.677c0,.011,0,.023,0,.034l.278-.733-.025.022",
    transform: "translate(-1211.886 -1021.574)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -199.425,
    y1: 103.878,
    x2: -199.26,
    y2: 103.878,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23527",
    "data-name": "Path 23527",
    d: "M1212.063,1022.071l-.232.613q0,.019,0,.038l.257-.677-.027.026",
    transform: "translate(-1211.831 -1022.045)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -216.981,
    y1: 112.375,
    x2: -216.802,
    y2: 112.375,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23528",
    "data-name": "Path 23528",
    d: "M1212.026,1022.643l-.2.534c0,.015,0,.03,0,.046l.233-.613-.03.033",
    transform: "translate(-1211.823 -1022.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -241.644,
    y1: 124.163,
    x2: -241.445,
    y2: 124.163,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23529",
    "data-name": "Path 23529",
    d: "M1212,1023.367l-.162.429a.553.553,0,0,0-.006.06l.2-.534c-.012.015-.024.03-.035.046",
    transform: "translate(-1211.834 -1023.321)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -277.882,
    y1: 142.38,
    x2: -277.653,
    y2: 142.38,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23530",
    "data-name": "Path 23530",
    d: "M1212.061,1024.4l-.03.08-.047.127a.59.59,0,0,0-.031.122l.163-.429a.6.6,0,0,0-.055.1",
    transform: "translate(-1211.953 -1024.304)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -346.272,
    y1: 177.288,
    x2: -345.987,
    y2: 177.288,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23531",
    "data-name": "Path 23531",
    d: "M1213.636,1026.493l-.017.047.03-.08c0,.01-.009.021-.013.032",
    transform: "translate(-1213.619 -1026.461)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -1870.197,
    y1: 955.092,
    x2: -1868.656,
    y2: 955.092,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23532",
    "data-name": "Path 23532",
    d: "M1204.477,1014.833l-.656,1.729.015.005.656-1.73Z",
    transform: "translate(-1203.821 -1014.833)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -83.349,
    y1: 44.06,
    x2: -83.28,
    y2: 44.06,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23534",
    "data-name": "Path 23534",
    d: "M1204.155,1014.714l-.656,1.73.015.005.656-1.73Z",
    transform: "translate(-1203.499 -1014.714)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -83.34,
    y1: 44.064,
    x2: -83.271,
    y2: 44.064,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23536",
    "data-name": "Path 23536",
    d: "M1203.831,1014.6l-.656,1.73.015.006.656-1.73Z",
    transform: "translate(-1203.175 -1014.596)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -83.311,
    y1: 44.067,
    x2: -83.242,
    y2: 44.067,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23538",
    "data-name": "Path 23538",
    d: "M1203.507,1014.477l-.656,1.73.015.006.656-1.73Z",
    transform: "translate(-1202.851 -1014.477)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -83.288,
    y1: 44.069,
    x2: -83.219,
    y2: 44.069,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23540",
    "data-name": "Path 23540",
    d: "M1203.183,1014.36l-.656,1.729.015.005.656-1.729Z",
    transform: "translate(-1202.527 -1014.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -83.265,
    y1: 44.074,
    x2: -83.196,
    y2: 44.074,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23542",
    "data-name": "Path 23542",
    d: "M1202.86,1014.241l-.656,1.729.015.005.656-1.729Z",
    transform: "translate(-1202.204 -1014.241)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -83.244,
    y1: 44.076,
    x2: -83.175,
    y2: 44.076,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23544",
    "data-name": "Path 23544",
    d: "M1202.536,1014.122l-.656,1.729.015.005.656-1.729Z",
    transform: "translate(-1201.88 -1014.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -83.216,
    y1: 44.079,
    x2: -83.147,
    y2: 44.079,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23546",
    "data-name": "Path 23546",
    d: "M1202.213,1014l-.656,1.73.015.005.656-1.73Z",
    transform: "translate(-1201.557 -1014.004)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -83.199,
    y1: 44.083,
    x2: -83.129,
    y2: 44.083,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23548",
    "data-name": "Path 23548",
    d: "M1201.889,1013.885l-.656,1.73.015.005.656-1.73Z",
    transform: "translate(-1201.233 -1013.885)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -83.176,
    y1: 44.086,
    x2: -83.106,
    y2: 44.086,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23550",
    "data-name": "Path 23550",
    d: "M1201.566,1013.767l-.656,1.73.015.006.656-1.73Z",
    transform: "translate(-1200.91 -1013.767)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -83.154,
    y1: 44.089,
    x2: -83.085,
    y2: 44.089,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23552",
    "data-name": "Path 23552",
    d: "M1201.242,1013.648l-.656,1.73.015.005.656-1.729Z",
    transform: "translate(-1200.586 -1013.648)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: -83.133,
    y1: 44.092,
    x2: -83.064,
    y2: 44.092,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23554",
    "data-name": "Path 23554",
    d: "M1200.918,1013.53l-.656,1.73.015.005.656-1.73Z",
    transform: "translate(-1200.262 -1013.53)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -83.103,
    y1: 44.095,
    x2: -83.034,
    y2: 44.095,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23556",
    "data-name": "Path 23556",
    d: "M1200.594,1013.411l-.656,1.73.015.005.656-1.73Z",
    transform: "translate(-1199.938 -1013.411)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -83.08,
    y1: 44.099,
    x2: -83.011,
    y2: 44.099,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23558",
    "data-name": "Path 23558",
    d: "M1200.579,1013.293l-.062.845-.356.972-.224-.082.656-1.73Z",
    transform: "translate(-1199.938 -1013.293)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -84.981,
    y1: 42.116,
    x2: -84.911,
    y2: 42.116,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23560",
    "data-name": "Path 23560",
    d: "M1208.616,1017.662l.174-.605.042.015Z",
    transform: "translate(-1208.616 -1017.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -260.025,
    y1: 126.127,
    x2: -259.81,
    y2: 126.127,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23562",
    "data-name": "Path 23562",
    d: "M1347.169,589.125c5.331,1.912,5.712,11.1,5.712,11.1s.159.638,1.331.487c.958-4.7-2.406-9.8-3.89-10.9a3.958,3.958,0,0,0-2.374-.763,3.547,3.547,0,0,0-.78.077",
    transform: "translate(-1347.169 -589.048)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -4.183,
    y1: 7.568,
    x2: -4.179,
    y2: 7.568,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23563",
    "data-name": "Path 23563",
    d: "M1406.055,823.69c.01.266-.058,1-.141,1.767a2.438,2.438,0,0,0,3.331,2.524c1.162-.467,2.228-1.7,2.518-4.525,0,0,1.075-3.77-1.847-4.941a2.039,2.039,0,0,0-.763-.158c-2.329,0-3.12,4.748-3.1,5.334",
    transform: "translate(-1405.9 -818.356)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -5.176,
    y1: 7.818,
    x2: -5.172,
    y2: 7.818,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23564",
    "data-name": "Path 23564",
    d: "M1441.248,842.288c-.5,1.377-1.542,6.916-.379,7.067,1.1.143,3.831-2.183,2.786-6.717a1.4,1.4,0,0,0-1.356-1.088h-.014a1.028,1.028,0,0,0-1.037.738",
    transform: "translate(-1440.338 -841.55)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -7.175,
    y1: 9.171,
    x2: -7.169,
    y2: 9.171,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23573",
    "data-name": "Path 23573",
    d: "M1749.189,66.489A15.692,15.692,0,1,0,1764.881,50.8a15.692,15.692,0,0,0-15.692,15.692",
    transform: "translate(-1749.189 -50.797)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -2.589,
    y1: 3.863,
    x2: -2.588,
    y2: 3.863,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23575",
    "data-name": "Path 23575",
    d: "M1854.818,284.932a4.125,4.125,0,0,0-1.2,1l.934.983a3.435,3.435,0,0,1,.688-.621,1.15,1.15,0,0,1,.608-.172.766.766,0,0,1,.6.258,1.132,1.132,0,0,1,.23.774,3.148,3.148,0,0,1-.117.857,4.226,4.226,0,0,1-.363.866,16.232,16.232,0,0,1-.9,1.386l-1.6,2.262v1.248h4.818v-1.487h-2.944v-.049q1.407-1.794,1.745-2.3a7.846,7.846,0,0,0,.562-.965,4.585,4.585,0,0,0,.335-.925,4.176,4.176,0,0,0,.111-.977,2.464,2.464,0,0,0-.612-1.776,2.24,2.24,0,0,0-1.7-.639,2.692,2.692,0,0,0-1.2.27",
    transform: "translate(-1853.62 -284.662)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: -8.286,
    y1: 11.415,
    x2: -8.281,
    y2: 11.415,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23576",
    "data-name": "Path 23576",
    d: "M1978.336,290.839a10.448,10.448,0,0,0,.467-1.211h.049l-.043.8-.031.836v1.893h-1.524Zm.227-3.4-2.716,5.74v1.358h2.932v1.887h1.573v-1.887h.909v-1.383h-.909v-5.715Z",
    transform: "translate(-1975.847 -287.441)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: -8.654,
    y1: 11.078,
    x2: -8.649,
    y2: 11.078,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23577",
    "data-name": "Path 23577",
    d: "M2101.82,287.441l-3.349,8.984h1.573l3.349-8.984Z",
    transform: "translate(-2098.471 -287.441)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -9.496,
    y1: 11.484,
    x2: -9.491,
    y2: 11.484,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23578",
    "data-name": "Path 23578",
    d: "M2216.6,287.705v1.481h3.134l-2.52,7.491h1.727l2.477-7.841v-1.131Z",
    transform: "translate(-2216.597 -287.705)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -10.122,
    y1: 11.584,
    x2: -10.118,
    y2: 11.584,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12948",
    "data-name": "Group 12948",
    transform: "translate(-1084.553 -600.466)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 38.53,
    cy: 38.53,
    r: 38.53,
    transform: "translate(1104.327 633.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12947",
    "data-name": "Group 12947",
    transform: "translate(1084.553 600.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12946",
    "data-name": "Group 12946",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12553",
    "data-name": "Group 12553",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12552",
    "data-name": "Group 12552",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23370",
    "data-name": "Path 23370",
    d: "M1864.448,69.444s-.358-15.063,6.58-19.094,20.129-6.552,20.623-28.181c.29-12.663.6-18.2.813-20.613A1.426,1.426,0,0,0,1890.78.029c-6.571,1.238-27.916,6.333-32.391,20.9-5.305,17.272,6.059,48.513,6.059,48.513",
    transform: "translate(-1770.708 -0.003)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12545",
    "data-name": "Group 12545",
    transform: "translate(91.682 5.974)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12544",
    "data-name": "Group 12544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12543",
    "data-name": "Group 12543",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23371",
    "data-name": "Path 23371",
    d: "M1996.778,128.664c-7.213,6.433-15.553,17.817-20,29.2a53.526,53.526,0,0,0-2.965,12.955,59.678,59.678,0,0,0,.459,16.3.482.482,0,0,0,.563.384.489.489,0,0,0,.386-.554,66.076,66.076,0,0,1,1.53-23.8c2.625-9.744,8.478-19.191,14.533-27.2l.623-.789c4.691-6.024,5.678-6.068,5.24-6.488a.274.274,0,0,0-.371-.007",
    transform: "translate(-1973.469 -128.596)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23372",
    "data-name": "Path 23372",
    d: "M1768.334,862.865c-1.034.507,9.787-13.1,13.177-34.471,1.6-10.07,1.618-22.688,7.355-27.55,4.774-4.047,21.021-1.492,26.337-.521a.8.8,0,0,1,.371,1.395c-2.549,2.141-8,7.191-9.423,12.28-1.873,6.708-8.25,10.975-13.96,12.13s-8.886,2.275-11.667,11.406-9.25,23.891-12.188,25.331",
    transform: "translate(-1686.117 -761.529)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12548",
    "data-name": "Group 12548",
    transform: "translate(95.59 41.628)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12547",
    "data-name": "Group 12547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12546",
    "data-name": "Group 12546",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23373",
    "data-name": "Path 23373",
    d: "M2083.61,896.049c-6.782.284-14.062,3.378-17.757,9.181l-.349.554a130.118,130.118,0,0,0-7.9,18.181.182.182,0,0,0,.115.23.185.185,0,0,0,.228-.109c1.766-4.323,4.3-9.8,6.323-13.9,2.167-4.472,3.683-7.5,8.625-10.4a27.511,27.511,0,0,1,10.74-3.443.146.146,0,0,0-.021-.291",
    transform: "translate(-2057.59 -896.049)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23374",
    "data-name": "Path 23374",
    d: "M1868.315,1379.114c-.613.323,3.456-6.68,3.768-12.851s1.7-16.7,7.025-23,11.148-6.875,18.49-1.147c6.119,4.772,9.935,7.181,12.174,7.629a.846.846,0,0,1,.568,1.233c-1.436,2.644-5.495,8.717-12.31,8.289-8.693-.545-19.228-6.2-22.439-1.482s-2.8,7.352-2.9,9.586-.318,9.6-4.378,11.745",
    transform: "translate(-1781.459 -1275.988)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12551",
    "data-name": "Group 12551",
    transform: "translate(91.468 69.04)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12550",
    "data-name": "Group 12550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12549",
    "data-name": "Group 12549",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23375",
    "data-name": "Path 23375",
    d: "M1991.073,1490.749c-2.663-2.553-7-5.062-10.791-4.594-4.932.794-8.217,4.088-10.009,8.99a29.918,29.918,0,0,0-1.4,5.745.162.162,0,0,0,.317.066c.3-1.2.6-2.453,1.047-3.751,2.6-8.374,8.148-9.5,8.364-9.673.42.041,2.963-1.863,9,1.385a26.754,26.754,0,0,1,3.254,2.086l.006,0a.169.169,0,0,0,.218-.257",
    transform: "translate(-1968.868 -1486.098)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12555",
    "data-name": "Group 12555",
    transform: "translate(5.378 19.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12554",
    "data-name": "Group 12554",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6372",
    "data-name": "Rectangle 6372",
    width: 148.319,
    height: 148.299,
    transform: "matrix(0.735, -0.679, 0.679, 0.735, -52.581, 48.234)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12557",
    "data-name": "Group 12557",
    transform: "translate(26.267 59.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12556",
    "data-name": "Group 12556",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6373",
    "data-name": "Rectangle 6373",
    width: 76.698,
    height: 76.782,
    transform: "matrix(0.696, -0.718, 0.718, 0.696, -27.341, 27.016)",
    fill: "#dd2d38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12559",
    "data-name": "Group 12559",
    transform: "translate(55.434 42.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12558",
    "data-name": "Group 12558",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6374",
    "data-name": "Rectangle 6374",
    width: 17.076,
    height: 22.657,
    transform: "translate(-4.634 1.068) rotate(-13.269)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12561",
    "data-name": "Group 12561",
    transform: "translate(52.928 33.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12560",
    "data-name": "Group 12560",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6375",
    "data-name": "Rectangle 6375",
    width: 22.821,
    height: 21.488,
    transform: "translate(-5.037 17.859) rotate(-75.329)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12563",
    "data-name": "Group 12563",
    transform: "translate(49.756 25.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12562",
    "data-name": "Group 12562",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6376",
    "data-name": "Rectangle 6376",
    width: 34.086,
    height: 33.484,
    transform: "matrix(0.762, -0.647, 0.647, 0.762, -11.493, 8.875)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12565",
    "data-name": "Group 12565",
    transform: "translate(65.392 39.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12564",
    "data-name": "Group 12564",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6377",
    "data-name": "Rectangle 6377",
    width: 7.367,
    height: 6.693,
    transform: "matrix(0.253, -0.967, 0.967, 0.253, -1.527, 5.831)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12567",
    "data-name": "Group 12567",
    transform: "translate(71.739 62.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12566",
    "data-name": "Group 12566",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6378",
    "data-name": "Rectangle 6378",
    width: 44.34,
    height: 44.034,
    transform: "matrix(0.696, -0.718, 0.718, 0.696, -19.11, 19.659)",
    fill: "#dd2d38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12569",
    "data-name": "Group 12569",
    transform: "translate(72.423 78.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12568",
    "data-name": "Group 12568",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6379",
    "data-name": "Rectangle 6379",
    width: 14.275,
    height: 14.123,
    transform: "matrix(0.694, -0.72, 0.72, 0.694, -6.525, 6.762)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12571",
    "data-name": "Group 12571",
    transform: "translate(61.448 93.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12570",
    "data-name": "Group 12570",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6380",
    "data-name": "Rectangle 6380",
    width: 26.042,
    height: 32.477,
    transform: "translate(-5.688 14.969) rotate(-69.193)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12573",
    "data-name": "Group 12573",
    transform: "translate(50.017 100.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12572",
    "data-name": "Group 12572",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6381",
    "data-name": "Rectangle 6381",
    width: 9.783,
    height: 14.786,
    transform: "matrix(0.355, -0.935, 0.935, 0.355, -2.145, 4.55)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12575",
    "data-name": "Group 12575",
    transform: "translate(33.342 101.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12574",
    "data-name": "Group 12574",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6382",
    "data-name": "Rectangle 6382",
    width: 28.254,
    height: 23.872,
    transform: "matrix(0.79, -0.613, 0.613, 0.79, -3.143, 2.322)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12577",
    "data-name": "Group 12577",
    transform: "translate(34.174 102.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12576",
    "data-name": "Group 12576",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6383",
    "data-name": "Rectangle 6383",
    width: 11.067,
    height: 9.716,
    transform: "translate(-1.735 1.347) rotate(-37.823)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12579",
    "data-name": "Group 12579",
    transform: "translate(0 63.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12578",
    "data-name": "Group 12578",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6384",
    "data-name": "Rectangle 6384",
    width: 59.011,
    height: 65.504,
    transform: "translate(-15.952 25.917) rotate(-58.627)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12581",
    "data-name": "Group 12581",
    transform: "translate(22.459 85.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12580",
    "data-name": "Group 12580",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6385",
    "data-name": "Rectangle 6385",
    width: 25.923,
    height: 24.026,
    transform: "translate(-7.954 17.114) rotate(-65.225)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12583",
    "data-name": "Group 12583",
    transform: "translate(19.688 104.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12582",
    "data-name": "Group 12582",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6386",
    "data-name": "Rectangle 6386",
    width: 6.96,
    height: 26.141,
    transform: "translate(-0.436 2.582) rotate(-80.412)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12585",
    "data-name": "Group 12585",
    transform: "translate(57.71 44.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12584",
    "data-name": "Group 12584",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6387",
    "data-name": "Rectangle 6387",
    width: 11.086,
    height: 10.111,
    transform: "translate(-2.582 1.86) rotate(-35.762)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12587",
    "data-name": "Group 12587",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12586",
    "data-name": "Group 12586",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6388",
    "data-name": "Rectangle 6388",
    width: 2.463,
    height: 1.835,
    transform: "translate(-0.077 0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12589",
    "data-name": "Group 12589",
    transform: "translate(58.285 48.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12588",
    "data-name": "Group 12588",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6389",
    "data-name": "Rectangle 6389",
    width: 0.092,
    height: 0.217,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12591",
    "data-name": "Group 12591",
    transform: "translate(58.24 48.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12590",
    "data-name": "Group 12590",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6390",
    "data-name": "Rectangle 6390",
    width: 0.378,
    height: 0.885,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12593",
    "data-name": "Group 12593",
    transform: "translate(58.219 48.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12592",
    "data-name": "Group 12592",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6391",
    "data-name": "Rectangle 6391",
    width: 0.357,
    height: 0.92,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12595",
    "data-name": "Group 12595",
    transform: "translate(58.198 48.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12594",
    "data-name": "Group 12594",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6392",
    "data-name": "Rectangle 6392",
    width: 0.37,
    height: 0.952,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12597",
    "data-name": "Group 12597",
    transform: "translate(58.177 48.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12596",
    "data-name": "Group 12596",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6393",
    "data-name": "Rectangle 6393",
    width: 0.382,
    height: 0.982,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12599",
    "data-name": "Group 12599",
    transform: "translate(58.157 48.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12598",
    "data-name": "Group 12598",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6394",
    "data-name": "Rectangle 6394",
    width: 0.393,
    height: 1.01,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12601",
    "data-name": "Group 12601",
    transform: "translate(58.137 48.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12600",
    "data-name": "Group 12600",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6395",
    "data-name": "Rectangle 6395",
    width: 0.403,
    height: 1.036,
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12603",
    "data-name": "Group 12603",
    transform: "translate(58.117 47.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12602",
    "data-name": "Group 12602",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6396",
    "data-name": "Rectangle 6396",
    width: 0.412,
    height: 1.06,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12605",
    "data-name": "Group 12605",
    transform: "translate(58.098 47.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12604",
    "data-name": "Group 12604",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6397",
    "data-name": "Rectangle 6397",
    width: 0.421,
    height: 1.083,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12607",
    "data-name": "Group 12607",
    transform: "translate(58.079 47.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12606",
    "data-name": "Group 12606",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6398",
    "data-name": "Rectangle 6398",
    width: 0.43,
    height: 1.104,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12609",
    "data-name": "Group 12609",
    transform: "translate(58.06 47.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12608",
    "data-name": "Group 12608",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6399",
    "data-name": "Rectangle 6399",
    width: 0.437,
    height: 1.123,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12611",
    "data-name": "Group 12611",
    transform: "translate(58.042 47.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12610",
    "data-name": "Group 12610",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6400",
    "data-name": "Rectangle 6400",
    width: 0.445,
    height: 1.142,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12613",
    "data-name": "Group 12613",
    transform: "translate(58.024 47.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12612",
    "data-name": "Group 12612",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6401",
    "data-name": "Rectangle 6401",
    width: 0.451,
    height: 1.159,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12615",
    "data-name": "Group 12615",
    transform: "translate(58.006 47.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12614",
    "data-name": "Group 12614",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6402",
    "data-name": "Rectangle 6402",
    width: 0.457,
    height: 1.175,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-23)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12617",
    "data-name": "Group 12617",
    transform: "translate(57.988 47.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12616",
    "data-name": "Group 12616",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6403",
    "data-name": "Rectangle 6403",
    width: 0.463,
    height: 1.189,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12619",
    "data-name": "Group 12619",
    transform: "translate(57.971 47.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12618",
    "data-name": "Group 12618",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6404",
    "data-name": "Rectangle 6404",
    width: 0.469,
    height: 1.203,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12621",
    "data-name": "Group 12621",
    transform: "translate(57.953 47.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12620",
    "data-name": "Group 12620",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6405",
    "data-name": "Rectangle 6405",
    width: 0.474,
    height: 1.216,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12623",
    "data-name": "Group 12623",
    transform: "translate(57.936 47.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12622",
    "data-name": "Group 12622",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6406",
    "data-name": "Rectangle 6406",
    width: 0.478,
    height: 1.227,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12625",
    "data-name": "Group 12625",
    transform: "translate(57.919 47.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12624",
    "data-name": "Group 12624",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6407",
    "data-name": "Rectangle 6407",
    width: 0.482,
    height: 1.238,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12627",
    "data-name": "Group 12627",
    transform: "translate(57.902 47.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12626",
    "data-name": "Group 12626",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6408",
    "data-name": "Rectangle 6408",
    width: 0.486,
    height: 1.248,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12629",
    "data-name": "Group 12629",
    transform: "translate(57.886 47.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12628",
    "data-name": "Group 12628",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6409",
    "data-name": "Rectangle 6409",
    width: 0.49,
    height: 1.258,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12631",
    "data-name": "Group 12631",
    transform: "translate(57.869 47.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12630",
    "data-name": "Group 12630",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6410",
    "data-name": "Rectangle 6410",
    width: 0.493,
    height: 1.266,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-31)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12633",
    "data-name": "Group 12633",
    transform: "translate(57.853 47.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12632",
    "data-name": "Group 12632",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6411",
    "data-name": "Rectangle 6411",
    width: 0.496,
    height: 1.273,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12635",
    "data-name": "Group 12635",
    transform: "translate(57.837 47.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12634",
    "data-name": "Group 12634",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6412",
    "data-name": "Rectangle 6412",
    width: 0.498,
    height: 1.28,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12637",
    "data-name": "Group 12637",
    transform: "translate(57.821 47.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12636",
    "data-name": "Group 12636",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6413",
    "data-name": "Rectangle 6413",
    width: 0.5,
    height: 1.286,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12639",
    "data-name": "Group 12639",
    transform: "translate(57.805 47.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12638",
    "data-name": "Group 12638",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6414",
    "data-name": "Rectangle 6414",
    width: 0.502,
    height: 1.29,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-35)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12641",
    "data-name": "Group 12641",
    transform: "translate(57.79 47.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12640",
    "data-name": "Group 12640",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6415",
    "data-name": "Rectangle 6415",
    width: 0.504,
    height: 1.294,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-36)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12643",
    "data-name": "Group 12643",
    transform: "translate(57.774 47.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12642",
    "data-name": "Group 12642",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6416",
    "data-name": "Rectangle 6416",
    width: 0.505,
    height: 1.298,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12645",
    "data-name": "Group 12645",
    transform: "translate(57.759 47.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12644",
    "data-name": "Group 12644",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6417",
    "data-name": "Rectangle 6417",
    width: 0.506,
    height: 1.3,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12647",
    "data-name": "Group 12647",
    transform: "translate(57.744 47.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12646",
    "data-name": "Group 12646",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6418",
    "data-name": "Rectangle 6418",
    width: 0.506,
    height: 1.302,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12649",
    "data-name": "Group 12649",
    transform: "translate(57.728 47.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12648",
    "data-name": "Group 12648",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6419",
    "data-name": "Rectangle 6419",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-40)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12651",
    "data-name": "Group 12651",
    transform: "translate(57.713 47.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12650",
    "data-name": "Group 12650",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6420",
    "data-name": "Rectangle 6420",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12653",
    "data-name": "Group 12653",
    transform: "translate(57.698 47.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12652",
    "data-name": "Group 12652",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6421",
    "data-name": "Rectangle 6421",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12655",
    "data-name": "Group 12655",
    transform: "translate(57.683 47.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12654",
    "data-name": "Group 12654",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6422",
    "data-name": "Rectangle 6422",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-43)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12657",
    "data-name": "Group 12657",
    transform: "translate(57.668 47.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12656",
    "data-name": "Group 12656",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6423",
    "data-name": "Rectangle 6423",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-44)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12659",
    "data-name": "Group 12659",
    transform: "translate(57.653 47.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12658",
    "data-name": "Group 12658",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6424",
    "data-name": "Rectangle 6424",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12661",
    "data-name": "Group 12661",
    transform: "translate(57.638 47.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12660",
    "data-name": "Group 12660",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6425",
    "data-name": "Rectangle 6425",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12663",
    "data-name": "Group 12663",
    transform: "translate(57.623 47.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12662",
    "data-name": "Group 12662",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6426",
    "data-name": "Rectangle 6426",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-47)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12665",
    "data-name": "Group 12665",
    transform: "translate(57.608 47.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12664",
    "data-name": "Group 12664",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6427",
    "data-name": "Rectangle 6427",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-48)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12667",
    "data-name": "Group 12667",
    transform: "translate(57.593 47.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12666",
    "data-name": "Group 12666",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6428",
    "data-name": "Rectangle 6428",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-49)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12669",
    "data-name": "Group 12669",
    transform: "translate(57.578 47.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12668",
    "data-name": "Group 12668",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6429",
    "data-name": "Rectangle 6429",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-50)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12671",
    "data-name": "Group 12671",
    transform: "translate(57.563 47.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12670",
    "data-name": "Group 12670",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6430",
    "data-name": "Rectangle 6430",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12673",
    "data-name": "Group 12673",
    transform: "translate(57.548 47.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6431",
    "data-name": "Rectangle 6431",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-52)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12675",
    "data-name": "Group 12675",
    transform: "translate(57.533 47.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12674",
    "data-name": "Group 12674",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6432",
    "data-name": "Rectangle 6432",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12677",
    "data-name": "Group 12677",
    transform: "translate(57.518 47.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12676",
    "data-name": "Group 12676",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6433",
    "data-name": "Rectangle 6433",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-54)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12679",
    "data-name": "Group 12679",
    transform: "translate(57.503 47.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12678",
    "data-name": "Group 12678",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6434",
    "data-name": "Rectangle 6434",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-55)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12681",
    "data-name": "Group 12681",
    transform: "translate(57.488 47.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12680",
    "data-name": "Group 12680",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6435",
    "data-name": "Rectangle 6435",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-56)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12683",
    "data-name": "Group 12683",
    transform: "translate(57.473 47.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12682",
    "data-name": "Group 12682",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6436",
    "data-name": "Rectangle 6436",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-57)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12685",
    "data-name": "Group 12685",
    transform: "translate(57.458 47.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12684",
    "data-name": "Group 12684",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6437",
    "data-name": "Rectangle 6437",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-58)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12687",
    "data-name": "Group 12687",
    transform: "translate(57.443 47.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12686",
    "data-name": "Group 12686",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6438",
    "data-name": "Rectangle 6438",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-59)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12689",
    "data-name": "Group 12689",
    transform: "translate(57.428 47.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12688",
    "data-name": "Group 12688",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6439",
    "data-name": "Rectangle 6439",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12691",
    "data-name": "Group 12691",
    transform: "translate(57.413 47.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12690",
    "data-name": "Group 12690",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6440",
    "data-name": "Rectangle 6440",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-61)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12693",
    "data-name": "Group 12693",
    transform: "translate(57.398 47.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12692",
    "data-name": "Group 12692",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6441",
    "data-name": "Rectangle 6441",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-62)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12695",
    "data-name": "Group 12695",
    transform: "translate(57.383 47.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12694",
    "data-name": "Group 12694",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6442",
    "data-name": "Rectangle 6442",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-63)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12697",
    "data-name": "Group 12697",
    transform: "translate(57.368 47.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12696",
    "data-name": "Group 12696",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6443",
    "data-name": "Rectangle 6443",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-64)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12699",
    "data-name": "Group 12699",
    transform: "translate(57.353 47.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12698",
    "data-name": "Group 12698",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6444",
    "data-name": "Rectangle 6444",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-65)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12701",
    "data-name": "Group 12701",
    transform: "translate(57.338 47.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12700",
    "data-name": "Group 12700",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6445",
    "data-name": "Rectangle 6445",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12703",
    "data-name": "Group 12703",
    transform: "translate(57.323 47.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12702",
    "data-name": "Group 12702",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6446",
    "data-name": "Rectangle 6446",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-67)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12705",
    "data-name": "Group 12705",
    transform: "translate(57.308 47.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12704",
    "data-name": "Group 12704",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6447",
    "data-name": "Rectangle 6447",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-68)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12707",
    "data-name": "Group 12707",
    transform: "translate(57.293 47.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12706",
    "data-name": "Group 12706",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6448",
    "data-name": "Rectangle 6448",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-69)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12709",
    "data-name": "Group 12709",
    transform: "translate(57.277 47.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12708",
    "data-name": "Group 12708",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6449",
    "data-name": "Rectangle 6449",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-70)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12711",
    "data-name": "Group 12711",
    transform: "translate(57.262 47.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12710",
    "data-name": "Group 12710",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6450",
    "data-name": "Rectangle 6450",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-71)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12713",
    "data-name": "Group 12713",
    transform: "translate(57.247 47.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12712",
    "data-name": "Group 12712",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-72)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12715",
    "data-name": "Group 12715",
    transform: "translate(57.232 47.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12714",
    "data-name": "Group 12714",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6452",
    "data-name": "Rectangle 6452",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12717",
    "data-name": "Group 12717",
    transform: "translate(57.217 47.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12716",
    "data-name": "Group 12716",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6453",
    "data-name": "Rectangle 6453",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12719",
    "data-name": "Group 12719",
    transform: "translate(57.202 47.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12718",
    "data-name": "Group 12718",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6454",
    "data-name": "Rectangle 6454",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-75)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12721",
    "data-name": "Group 12721",
    transform: "translate(57.187 47.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12720",
    "data-name": "Group 12720",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6455",
    "data-name": "Rectangle 6455",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-76)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12723",
    "data-name": "Group 12723",
    transform: "translate(57.172 47.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12722",
    "data-name": "Group 12722",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6456",
    "data-name": "Rectangle 6456",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-77)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12725",
    "data-name": "Group 12725",
    transform: "translate(57.157 47.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12724",
    "data-name": "Group 12724",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6457",
    "data-name": "Rectangle 6457",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-78)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12727",
    "data-name": "Group 12727",
    transform: "translate(57.142 47.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12726",
    "data-name": "Group 12726",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6458",
    "data-name": "Rectangle 6458",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-79)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12729",
    "data-name": "Group 12729",
    transform: "translate(57.127 47.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12728",
    "data-name": "Group 12728",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6459",
    "data-name": "Rectangle 6459",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-80)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12731",
    "data-name": "Group 12731",
    transform: "translate(57.112 47.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12730",
    "data-name": "Group 12730",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6460",
    "data-name": "Rectangle 6460",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-81)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12733",
    "data-name": "Group 12733",
    transform: "translate(57.097 47.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12732",
    "data-name": "Group 12732",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6461",
    "data-name": "Rectangle 6461",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12735",
    "data-name": "Group 12735",
    transform: "translate(57.082 47.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12734",
    "data-name": "Group 12734",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6462",
    "data-name": "Rectangle 6462",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12737",
    "data-name": "Group 12737",
    transform: "translate(57.067 47.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12736",
    "data-name": "Group 12736",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6463",
    "data-name": "Rectangle 6463",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-84)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12739",
    "data-name": "Group 12739",
    transform: "translate(57.052 47.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12738",
    "data-name": "Group 12738",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6464",
    "data-name": "Rectangle 6464",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-85)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12741",
    "data-name": "Group 12741",
    transform: "translate(57.037 47.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12740",
    "data-name": "Group 12740",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6465",
    "data-name": "Rectangle 6465",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12743",
    "data-name": "Group 12743",
    transform: "translate(57.022 47.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12742",
    "data-name": "Group 12742",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6466",
    "data-name": "Rectangle 6466",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-87)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    transform: "translate(57.007 47.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12744",
    "data-name": "Group 12744",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6467",
    "data-name": "Rectangle 6467",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-88)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12747",
    "data-name": "Group 12747",
    transform: "translate(56.992 47.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12746",
    "data-name": "Group 12746",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6468",
    "data-name": "Rectangle 6468",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12749",
    "data-name": "Group 12749",
    transform: "translate(56.977 47.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12748",
    "data-name": "Group 12748",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6469",
    "data-name": "Rectangle 6469",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-90)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12751",
    "data-name": "Group 12751",
    transform: "translate(56.962 47.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12750",
    "data-name": "Group 12750",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6470",
    "data-name": "Rectangle 6470",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-91)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12753",
    "data-name": "Group 12753",
    transform: "translate(56.947 47.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12752",
    "data-name": "Group 12752",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6471",
    "data-name": "Rectangle 6471",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-92)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12755",
    "data-name": "Group 12755",
    transform: "translate(56.932 47.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12754",
    "data-name": "Group 12754",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6472",
    "data-name": "Rectangle 6472",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-93)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12757",
    "data-name": "Group 12757",
    transform: "translate(56.917 47.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12756",
    "data-name": "Group 12756",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6473",
    "data-name": "Rectangle 6473",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12759",
    "data-name": "Group 12759",
    transform: "translate(56.902 47.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12758",
    "data-name": "Group 12758",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6474",
    "data-name": "Rectangle 6474",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-95)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12761",
    "data-name": "Group 12761",
    transform: "translate(56.887 47.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12760",
    "data-name": "Group 12760",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6475",
    "data-name": "Rectangle 6475",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-96)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12763",
    "data-name": "Group 12763",
    transform: "translate(56.872 47.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12762",
    "data-name": "Group 12762",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6476",
    "data-name": "Rectangle 6476",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-97)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12765",
    "data-name": "Group 12765",
    transform: "translate(56.857 47.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12764",
    "data-name": "Group 12764",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6477",
    "data-name": "Rectangle 6477",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-98)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12767",
    "data-name": "Group 12767",
    transform: "translate(56.842 47.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12766",
    "data-name": "Group 12766",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6478",
    "data-name": "Rectangle 6478",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-99)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12769",
    "data-name": "Group 12769",
    transform: "translate(56.827 47.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12768",
    "data-name": "Group 12768",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6479",
    "data-name": "Rectangle 6479",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-100)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12771",
    "data-name": "Group 12771",
    transform: "translate(56.811 47.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12770",
    "data-name": "Group 12770",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6480",
    "data-name": "Rectangle 6480",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-101)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12773",
    "data-name": "Group 12773",
    transform: "translate(56.796 47.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12772",
    "data-name": "Group 12772",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6481",
    "data-name": "Rectangle 6481",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-102)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12775",
    "data-name": "Group 12775",
    transform: "translate(56.781 47.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12774",
    "data-name": "Group 12774",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6482",
    "data-name": "Rectangle 6482",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-103)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12777",
    "data-name": "Group 12777",
    transform: "translate(56.766 47.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12776",
    "data-name": "Group 12776",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6483",
    "data-name": "Rectangle 6483",
    width: 0.507,
    height: 1.303,
    fill: "url(#linear-gradient-104)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12779",
    "data-name": "Group 12779",
    transform: "translate(56.751 47.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12778",
    "data-name": "Group 12778",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6484",
    "data-name": "Rectangle 6484",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-105)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12781",
    "data-name": "Group 12781",
    transform: "translate(56.736 47.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12780",
    "data-name": "Group 12780",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6485",
    "data-name": "Rectangle 6485",
    width: 0.507,
    height: 1.303,
    transform: "translate(0)",
    fill: "url(#linear-gradient-106)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12783",
    "data-name": "Group 12783",
    transform: "translate(56.721 47.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12782",
    "data-name": "Group 12782",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6486",
    "data-name": "Rectangle 6486",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-107)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12785",
    "data-name": "Group 12785",
    transform: "translate(56.706 47.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12784",
    "data-name": "Group 12784",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6487",
    "data-name": "Rectangle 6487",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-108)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12787",
    "data-name": "Group 12787",
    transform: "translate(56.691 47.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12786",
    "data-name": "Group 12786",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6488",
    "data-name": "Rectangle 6488",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-109)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12789",
    "data-name": "Group 12789",
    transform: "translate(56.676 47.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12788",
    "data-name": "Group 12788",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6489",
    "data-name": "Rectangle 6489",
    width: 0.507,
    height: 1.303,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-110)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12791",
    "data-name": "Group 12791",
    transform: "translate(56.661 47.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12790",
    "data-name": "Group 12790",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6490",
    "data-name": "Rectangle 6490",
    width: 0.507,
    height: 1.302,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-111)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12793",
    "data-name": "Group 12793",
    transform: "translate(56.647 47.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12792",
    "data-name": "Group 12792",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6491",
    "data-name": "Rectangle 6491",
    width: 0.506,
    height: 1.301,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12795",
    "data-name": "Group 12795",
    transform: "translate(56.632 47.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12794",
    "data-name": "Group 12794",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6492",
    "data-name": "Rectangle 6492",
    width: 0.505,
    height: 1.299,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-113)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12797",
    "data-name": "Group 12797",
    transform: "translate(56.618 47.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12796",
    "data-name": "Group 12796",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6493",
    "data-name": "Rectangle 6493",
    width: 0.504,
    height: 1.296,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-114)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12799",
    "data-name": "Group 12799",
    transform: "translate(56.604 47.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12798",
    "data-name": "Group 12798",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6494",
    "data-name": "Rectangle 6494",
    width: 0.503,
    height: 1.293,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-115)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12801",
    "data-name": "Group 12801",
    transform: "translate(56.59 47.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12800",
    "data-name": "Group 12800",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6495",
    "data-name": "Rectangle 6495",
    width: 0.501,
    height: 1.288,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-116)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12803",
    "data-name": "Group 12803",
    transform: "translate(56.576 47.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12802",
    "data-name": "Group 12802",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6496",
    "data-name": "Rectangle 6496",
    width: 0.499,
    height: 1.283,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-117)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12805",
    "data-name": "Group 12805",
    transform: "translate(56.562 47.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12804",
    "data-name": "Group 12804",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6497",
    "data-name": "Rectangle 6497",
    width: 0.497,
    height: 1.277,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-118)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12807",
    "data-name": "Group 12807",
    transform: "translate(56.549 47.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12806",
    "data-name": "Group 12806",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6498",
    "data-name": "Rectangle 6498",
    width: 0.494,
    height: 1.27,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-119)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12809",
    "data-name": "Group 12809",
    transform: "translate(56.535 47.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12808",
    "data-name": "Group 12808",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6499",
    "data-name": "Rectangle 6499",
    width: 0.491,
    height: 1.262,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-120)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12811",
    "data-name": "Group 12811",
    transform: "translate(56.522 47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12810",
    "data-name": "Group 12810",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6500",
    "data-name": "Rectangle 6500",
    width: 0.488,
    height: 1.253,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-121)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12813",
    "data-name": "Group 12813",
    transform: "translate(56.509 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12812",
    "data-name": "Group 12812",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6501",
    "data-name": "Rectangle 6501",
    width: 0.484,
    height: 1.243,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-122)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12815",
    "data-name": "Group 12815",
    transform: "translate(56.496 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12814",
    "data-name": "Group 12814",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6502",
    "data-name": "Rectangle 6502",
    width: 0.48,
    height: 1.233,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-123)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12817",
    "data-name": "Group 12817",
    transform: "translate(56.483 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12816",
    "data-name": "Group 12816",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6503",
    "data-name": "Rectangle 6503",
    width: 0.476,
    height: 1.222,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-124)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12819",
    "data-name": "Group 12819",
    transform: "translate(56.471 47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12818",
    "data-name": "Group 12818",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6504",
    "data-name": "Rectangle 6504",
    width: 0.471,
    height: 1.209,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-125)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12821",
    "data-name": "Group 12821",
    transform: "translate(56.459 47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12820",
    "data-name": "Group 12820",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6505",
    "data-name": "Rectangle 6505",
    width: 0.466,
    height: 1.196,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-126)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12823",
    "data-name": "Group 12823",
    transform: "translate(56.447 47.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12822",
    "data-name": "Group 12822",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6506",
    "data-name": "Rectangle 6506",
    width: 0.46,
    height: 1.182,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-127)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12825",
    "data-name": "Group 12825",
    transform: "translate(56.435 47.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12824",
    "data-name": "Group 12824",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6507",
    "data-name": "Rectangle 6507",
    width: 0.454,
    height: 1.167,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-128)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12827",
    "data-name": "Group 12827",
    transform: "translate(56.423 47.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12826",
    "data-name": "Group 12826",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6508",
    "data-name": "Rectangle 6508",
    width: 0.448,
    height: 1.15,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-129)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12829",
    "data-name": "Group 12829",
    transform: "translate(56.412 47.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12828",
    "data-name": "Group 12828",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6509",
    "data-name": "Rectangle 6509",
    width: 0.441,
    height: 1.133,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-130)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12831",
    "data-name": "Group 12831",
    transform: "translate(56.401 47.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12830",
    "data-name": "Group 12830",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6510",
    "data-name": "Rectangle 6510",
    width: 0.434,
    height: 1.114,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-131)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12833",
    "data-name": "Group 12833",
    transform: "translate(56.39 47.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12832",
    "data-name": "Group 12832",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6511",
    "data-name": "Rectangle 6511",
    width: 0.425,
    height: 1.093,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-132)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12835",
    "data-name": "Group 12835",
    transform: "translate(56.38 47.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12834",
    "data-name": "Group 12834",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6512",
    "data-name": "Rectangle 6512",
    width: 0.417,
    height: 1.072,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-133)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12837",
    "data-name": "Group 12837",
    transform: "translate(56.369 47.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12836",
    "data-name": "Group 12836",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6513",
    "data-name": "Rectangle 6513",
    width: 0.408,
    height: 1.048,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-134)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12839",
    "data-name": "Group 12839",
    transform: "translate(56.359 47.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12838",
    "data-name": "Group 12838",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6514",
    "data-name": "Rectangle 6514",
    width: 0.398,
    height: 1.023,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-135)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12841",
    "data-name": "Group 12841",
    transform: "translate(56.35 47.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12840",
    "data-name": "Group 12840",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6515",
    "data-name": "Rectangle 6515",
    width: 0.387,
    height: 0.997,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12843",
    "data-name": "Group 12843",
    transform: "translate(56.341 47.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12842",
    "data-name": "Group 12842",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6516",
    "data-name": "Rectangle 6516",
    width: 0.376,
    height: 0.968,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-137)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12845",
    "data-name": "Group 12845",
    transform: "translate(56.332 47.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12844",
    "data-name": "Group 12844",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6517",
    "data-name": "Rectangle 6517",
    width: 0.364,
    height: 0.936,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-138)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12847",
    "data-name": "Group 12847",
    transform: "translate(56.324 47.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12846",
    "data-name": "Group 12846",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6518",
    "data-name": "Rectangle 6518",
    width: 0.35,
    height: 0.903,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-139)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12849",
    "data-name": "Group 12849",
    transform: "translate(56.317 47.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12848",
    "data-name": "Group 12848",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6519",
    "data-name": "Rectangle 6519",
    width: 0.336,
    height: 0.866,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-140)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12851",
    "data-name": "Group 12851",
    transform: "translate(56.311 47.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12850",
    "data-name": "Group 12850",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6520",
    "data-name": "Rectangle 6520",
    width: 0.32,
    height: 0.826,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-141)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12853",
    "data-name": "Group 12853",
    transform: "translate(56.305 47.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12852",
    "data-name": "Group 12852",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6521",
    "data-name": "Rectangle 6521",
    width: 0.302,
    height: 0.782,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-142)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12855",
    "data-name": "Group 12855",
    transform: "translate(56.301 47.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12854",
    "data-name": "Group 12854",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6522",
    "data-name": "Rectangle 6522",
    width: 0.282,
    height: 0.733,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-143)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12857",
    "data-name": "Group 12857",
    transform: "translate(56.298 47.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12856",
    "data-name": "Group 12856",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6523",
    "data-name": "Rectangle 6523",
    width: 0.259,
    height: 0.677,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-144)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12859",
    "data-name": "Group 12859",
    transform: "translate(56.298 47.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12858",
    "data-name": "Group 12858",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6524",
    "data-name": "Rectangle 6524",
    width: 0.233,
    height: 0.613,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-145)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12861",
    "data-name": "Group 12861",
    transform: "translate(56.298 47.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12860",
    "data-name": "Group 12860",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6525",
    "data-name": "Rectangle 6525",
    width: 0.203,
    height: 0.534,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-146)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12863",
    "data-name": "Group 12863",
    transform: "translate(56.304 47.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12862",
    "data-name": "Group 12862",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6526",
    "data-name": "Rectangle 6526",
    width: 0.163,
    height: 0.429,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-147)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12865",
    "data-name": "Group 12865",
    transform: "translate(56.381 47.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12864",
    "data-name": "Group 12864",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6527",
    "data-name": "Rectangle 6527",
    width: 0.03,
    height: 0.079,
    transform: "translate(0)",
    fill: "url(#linear-gradient-148)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12869",
    "data-name": "Group 12869",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12868",
    "data-name": "Group 12868",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12867",
    "data-name": "Group 12867",
    transform: "translate(-0.372 -0.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12866",
    "data-name": "Group 12866",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6528",
    "data-name": "Rectangle 6528",
    width: 0.671,
    height: 1.735,
    transform: "translate(0)",
    fill: "url(#linear-gradient-149)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12873",
    "data-name": "Group 12873",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12872",
    "data-name": "Group 12872",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12871",
    "data-name": "Group 12871",
    transform: "translate(-0.387 -0.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12870",
    "data-name": "Group 12870",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6529",
    "data-name": "Rectangle 6529",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-150)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12877",
    "data-name": "Group 12877",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12876",
    "data-name": "Group 12876",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12875",
    "data-name": "Group 12875",
    transform: "translate(-0.402 -0.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12874",
    "data-name": "Group 12874",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6530",
    "data-name": "Rectangle 6530",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-151)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12881",
    "data-name": "Group 12881",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12880",
    "data-name": "Group 12880",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12879",
    "data-name": "Group 12879",
    transform: "translate(-0.417 -0.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12878",
    "data-name": "Group 12878",
    clipPath: "url(#clip-path-169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6531",
    "data-name": "Rectangle 6531",
    width: 0.671,
    height: 1.735,
    transform: "translate(0)",
    fill: "url(#linear-gradient-152)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12885",
    "data-name": "Group 12885",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12884",
    "data-name": "Group 12884",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12883",
    "data-name": "Group 12883",
    transform: "translate(-0.432 -0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12882",
    "data-name": "Group 12882",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6532",
    "data-name": "Rectangle 6532",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-153)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12889",
    "data-name": "Group 12889",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12888",
    "data-name": "Group 12888",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12887",
    "data-name": "Group 12887",
    transform: "translate(-0.447 -0.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12886",
    "data-name": "Group 12886",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6533",
    "data-name": "Rectangle 6533",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-154)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12893",
    "data-name": "Group 12893",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12892",
    "data-name": "Group 12892",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12891",
    "data-name": "Group 12891",
    transform: "translate(-0.462 -0.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12890",
    "data-name": "Group 12890",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6534",
    "data-name": "Rectangle 6534",
    width: 0.671,
    height: 1.735,
    fill: "url(#linear-gradient-155)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12897",
    "data-name": "Group 12897",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12896",
    "data-name": "Group 12896",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12895",
    "data-name": "Group 12895",
    transform: "translate(-0.477 -0.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12894",
    "data-name": "Group 12894",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6535",
    "data-name": "Rectangle 6535",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-156)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12901",
    "data-name": "Group 12901",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12900",
    "data-name": "Group 12900",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12899",
    "data-name": "Group 12899",
    transform: "translate(-0.492 -0.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12898",
    "data-name": "Group 12898",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6536",
    "data-name": "Rectangle 6536",
    width: 0.671,
    height: 1.735,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-157)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12905",
    "data-name": "Group 12905",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12904",
    "data-name": "Group 12904",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12903",
    "data-name": "Group 12903",
    transform: "translate(-0.507 -0.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12902",
    "data-name": "Group 12902",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6537",
    "data-name": "Rectangle 6537",
    width: 0.671,
    height: 1.735,
    fill: "url(#linear-gradient-158)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12909",
    "data-name": "Group 12909",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12908",
    "data-name": "Group 12908",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12907",
    "data-name": "Group 12907",
    transform: "translate(-0.522 -0.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12906",
    "data-name": "Group 12906",
    clipPath: "url(#clip-path-183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6538",
    "data-name": "Rectangle 6538",
    width: 0.671,
    height: 1.735,
    fill: "url(#linear-gradient-159)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12913",
    "data-name": "Group 12913",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12912",
    "data-name": "Group 12912",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12911",
    "data-name": "Group 12911",
    transform: "translate(-0.537 -0.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12910",
    "data-name": "Group 12910",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6539",
    "data-name": "Rectangle 6539",
    width: 0.671,
    height: 1.735,
    fill: "url(#linear-gradient-160)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12917",
    "data-name": "Group 12917",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12916",
    "data-name": "Group 12916",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12915",
    "data-name": "Group 12915",
    transform: "translate(-0.552 -0.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12914",
    "data-name": "Group 12914",
    clipPath: "url(#clip-path-187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6540",
    "data-name": "Rectangle 6540",
    width: 0.671,
    height: 1.735,
    transform: "translate(0)",
    fill: "url(#linear-gradient-161)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12921",
    "data-name": "Group 12921",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12920",
    "data-name": "Group 12920",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12919",
    "data-name": "Group 12919",
    transform: "translate(-0.552 -0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12918",
    "data-name": "Group 12918",
    clipPath: "url(#clip-path-189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6541",
    "data-name": "Rectangle 6541",
    width: 0.656,
    height: 1.817,
    transform: "translate(0)",
    fill: "url(#linear-gradient-162)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12925",
    "data-name": "Group 12925",
    transform: "translate(56.298 47.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12924",
    "data-name": "Group 12924",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12923",
    "data-name": "Group 12923",
    transform: "translate(-0.149 -0.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12922",
    "data-name": "Group 12922",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6542",
    "data-name": "Rectangle 6542",
    width: 0.216,
    height: 0.605,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-163)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12927",
    "data-name": "Group 12927",
    transform: "translate(62.585 27.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12926",
    "data-name": "Group 12926",
    clipPath: "url(#clip-path-192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6543",
    "data-name": "Rectangle 6543",
    width: 14.22,
    height: 12.779,
    transform: "translate(-5.06 8.95) rotate(-60.516)",
    fill: "url(#linear-gradient-164)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12929",
    "data-name": "Group 12929",
    transform: "translate(65.314 38.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12928",
    "data-name": "Group 12928",
    clipPath: "url(#clip-path-193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6544",
    "data-name": "Rectangle 6544",
    width: 12.112,
    height: 11.014,
    transform: "translate(-4.349 7.515) rotate(-60.385)",
    fill: "url(#linear-gradient-165)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12931",
    "data-name": "Group 12931",
    transform: "translate(66.914 39.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12930",
    "data-name": "Group 12930",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6545",
    "data-name": "Rectangle 6545",
    width: 8.962,
    height: 9.286,
    transform: "translate(-4.558 3.359) rotate(-40.547)",
    fill: "url(#linear-gradient-166)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12933",
    "data-name": "Group 12933",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12932",
    "data-name": "Group 12932",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23565",
    "data-name": "Path 23565",
    d: "M169.651,1429.715l.36-.045-2.22-17.508a2.3,2.3,0,0,0-2.142-2.005L124,1407.641l-.022.362,41.648,2.515a1.937,1.937,0,0,1,1.8,1.689Z",
    transform: "translate(-118.22 -1342.246)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6546",
    "data-name": "Rectangle 6546",
    width: 0.363,
    height: 3.821,
    transform: "translate(52.065 92.456) rotate(-7.177)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23566",
    "data-name": "Path 23566",
    d: "M182.926,125.633s-40.583-20.052-27.311-34.815,38.016-8.863,39.269,6.676-28.863,11.893-11.958,28.139",
    transform: "translate(-145.843 -78.49)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23567",
    "data-name": "Path 23567",
    d: "M275.44,339.028a.409.409,0,0,0,.409.409H293.76a.409.409,0,0,0,0-.818H275.849a.409.409,0,0,0-.409.409",
    transform: "translate(-262.644 -322.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23568",
    "data-name": "Path 23568",
    d: "M775.857,339.438h5.314a.409.409,0,1,0,0-.818h-5.314a.409.409,0,1,0,0,.818",
    transform: "translate(-739.423 -322.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23569",
    "data-name": "Path 23569",
    d: "M262.453,417.075a.409.409,0,0,0,.409.409h6.725a.409.409,0,0,0,0-.818h-6.725a.409.409,0,0,0-.409.409",
    transform: "translate(-250.26 -397.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23570",
    "data-name": "Path 23570",
    d: "M619.629,417.075a.409.409,0,0,0,.409.409h11.95a.409.409,0,0,0,0-.818h-11.95a.409.409,0,0,0-.409.409",
    transform: "translate(-590.843 -397.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23571",
    "data-name": "Path 23571",
    d: "M249.873,495.54h17.878a.409.409,0,0,0,0-.818H249.873a.409.409,0,1,0,0,.818",
    transform: "translate(-237.875 -471.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23572",
    "data-name": "Path 23572",
    d: "M731.053,495.54h6.189a.409.409,0,1,0,0-.818h-6.189a.409.409,0,1,0,0,.818",
    transform: "translate(-696.7 -471.739)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12935",
    "data-name": "Group 12935",
    transform: "translate(81.262 2.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12934",
    "data-name": "Group 12934",
    clipPath: "url(#clip-path-196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6548",
    "data-name": "Rectangle 6548",
    width: 31.384,
    height: 31.384,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-167)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12937",
    "data-name": "Group 12937",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12936",
    "data-name": "Group 12936",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23574",
    "data-name": "Path 23574",
    d: "M1818.087,108.17A13.866,13.866,0,1,1,1804.221,94.3a13.866,13.866,0,0,1,13.866,13.866",
    transform: "translate(-1707.18 -89.923)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12939",
    "data-name": "Group 12939",
    transform: "translate(86.114 13.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12938",
    "data-name": "Group 12938",
    clipPath: "url(#clip-path-198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6550",
    "data-name": "Rectangle 6550",
    width: 10.08,
    height: 9.694,
    transform: "matrix(0.66, -0.751, 0.751, 0.66, -4.519, 5.146)",
    fill: "url(#linear-gradient-168)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12941",
    "data-name": "Group 12941",
    transform: "translate(91.792 13.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12940",
    "data-name": "Group 12940",
    clipPath: "url(#clip-path-199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6551",
    "data-name": "Rectangle 6551",
    width: 10.324,
    height: 9.996,
    transform: "translate(-4.455 5.073) rotate(-48.715)",
    fill: "url(#linear-gradient-169)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12943",
    "data-name": "Group 12943",
    transform: "translate(97.489 13.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942",
    clipPath: "url(#clip-path-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6552",
    "data-name": "Rectangle 6552",
    width: 9.999,
    height: 9.627,
    transform: "matrix(0.66, -0.751, 0.751, 0.66, -4.455, 5.073)",
    fill: "url(#linear-gradient-170)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12945",
    "data-name": "Group 12945",
    transform: "translate(102.977 13.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12944",
    "data-name": "Group 12944",
    clipPath: "url(#clip-path-201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6553",
    "data-name": "Rectangle 6553",
    width: 9.921,
    height: 9.54,
    transform: "translate(-4.448 5.066) rotate(-48.715)",
    fill: "url(#linear-gradient-171)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContectUsIcon);
export default __webpack_public_path__ + "static/media/contect-us-icon.e44b1234cadc20ea62d9dfbf1824ebf6.svg";
export { ForwardRef as ReactComponent };